<template>
<div>
    <div class="publicMakeTopic app-body">
        <page-header @openLoginDiolog="goLogin"></page-header>
        <make-topic v-if="isShowPub"
                    @toLogin="goLogin"
                    :topic-info="publicInfo"></make-topic>
        <school-topic v-else-if="isShowPer"
                      @toLogin="goLogin"
                      :topic-info="schoolInfo"></school-topic>
        <public-collect v-else-if="isShowPubicCollect"
                        @toLogin="goLogin"
                        :topic-info="publicCollect"></public-collect>
        <paper-practice v-else-if="isShowPractice"
                        @toLogin="goLogin"
                        :topic-info="paperPartice"></paper-practice>
    </div>
      <div class="selectType yx-center" @click="goOrgQuestion">
            <img src="../../assets/img/tiku.png" alt="">
            <div class="c-fff">机构题库</div>
        </div>
        <div class="selectTypePub yx-center" @click="$router.push('/question/public')">
            <img src="../../assets/img/tiku.png" alt="">
            <div class="c-fff">公共题库</div>
        </div>
     <bottom-ground></bottom-ground>
    <login-diolog :show.sync="loginDiologShow"
                  @changeLoginState="haveLogin"/>

     </div>
</template>

<script>
import {
    GetMedicalQueationDetailByClassId,
    AddQuestionLog,
    MyCollection,
    MyCancelCollection
} from "@/api/course"
import PageHeader from "@/components/header";
import MakeTopic from "@/components/pubMakeTopic";
import SchoolTopic from "@/components/schoolMakeTopic";
import publicCollect from "@/components/pubMakeTopicCollect";
import PaperPractice from "@/components/pubMakePractive";
import BottomGround from "@/components/bottomnav";
import LoginDiolog from "@/components/loginDiolog";
export default {
    components: {
        LoginDiolog,
        PageHeader,
        MakeTopic,
        SchoolTopic,
        publicCollect,
        BottomGround,
        PaperPractice
    },
    data() {
        return {
            passColumName: "",
            count: {},
            orginObj: {},
            dataList: [],
            publicInfo: {},
            schoolInfo: {},
            publicCollect: {},
            paperPartice: {},
            isShowPub: false,
            isShowPer: false,
            isShowPubicCollect: false,
            isShowPractice: false,
            loginDiologShow: false
        }
    },
    computed: {},
    watch: {

    },
    created() {
        window.scroll(0, 0)
        let passTopicInfo = JSON.parse(window.localStorage.getItem("TopicInfo"))
        if (passTopicInfo.type === "public") {
            this.isShowPub = true
            this.isShowPer = false
            this.isShowPubicCollect = false
            this.isShowPractice = false
            this.publicInfo = passTopicInfo
        } else if (passTopicInfo.type === "person") {
            this.isShowPer = true
            this.isShowPub = false
            this.isShowPubicCollect = false
            this.isShowPractice = false
            this.schoolInfo = passTopicInfo
        } else if (passTopicInfo.type === "publicCollect") {
            this.isShowPer = false
            this.isShowPub = false
            this.isShowPractice = false
            this.isShowPubicCollect = true
            this.publicCollect = passTopicInfo
        } else if (passTopicInfo.type === "practice") {
            this.isShowPer = false
            this.isShowPub = false
            this.isShowPubicCollect = false
            this.isShowPractice = true
            this.paperPartice = passTopicInfo
        }
        this.$bus.$on("pc-login-success", this.loginSuccess)
    },
    methods: {
        goLogin() {
            this.loginDiologShow = true
        },
        loginSuccess () {
            window.location.reload()
        },
        haveLogin(val) {
            this.isHaveLoginObj = val
        },
        goOrgQuestion () {
            if (!this.$store.getters.isLogin) {
                return this.goLogin();
            }
            this.$router.push("/question/organ")
        }
    },
    beforeDestroy() {
        this.$bus.$off("pc-login-success", this.loginSuccess)
    }

}

</script>

<style scoped lang="less">
    .publicMakeTopic {
        width: 100%;
        margin-bottom: 30px;

    }
    .selectType {
            width: 80px;
            height: 88px;
            background: #256CF4;
            box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
            border-radius: 8px;
            position: fixed;
            right: 40px;
            bottom: 365px;

            img {
                width: 35px;
                height: 40px;
            }
        }
        .selectTypePub {
            width: 80px;
            height: 88px;
            background: #256CF4;
            box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
            border-radius: 8px;
            position: fixed;
            right: 40px;
            bottom: 470px;

            img {
                width: 35px;
                height: 40px;
            }
        }

</style>
